import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NbButtonModule, NbCardModule, NbDialogModule, NbFormFieldModule, NbIconModule, NbInputModule, NbLayoutModule, NbMenuModule, NbSelectModule, NbSpinnerModule, NbTooltipModule } from '@nebular/theme';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ThemeModule } from '../../@theme/theme.module';
import { ConfirmationDialogComponent } from './confirmation-dialog/confirmation-dialog.component';
import { PartnerTypesDialogComponent } from './partner-types-dialog/partner-types-dialog.component';
import { EditBookingDialogComponent } from './edit-booking-dialog/edit-booking-dialog.component';
import { ClassifiedInfoDialogComponent } from './classified-info-dialog/classified-info-dialog.component';
import { RefuseNoteDialogComponent } from './refuse-note-dialog/refuse-note-dialog.component';



@NgModule({
  declarations: [
    ConfirmationDialogComponent,
    PartnerTypesDialogComponent,
    EditBookingDialogComponent,
    ClassifiedInfoDialogComponent,
    RefuseNoteDialogComponent,
  ],
  imports: [
    CommonModule,
    NbCardModule,
    NbDialogModule,
    NbMenuModule,
    ThemeModule,
    NbInputModule,
    FormsModule,
    NbButtonModule,
    NbSpinnerModule,
    NbFormFieldModule,
    NbLayoutModule,
    ReactiveFormsModule,
    NbIconModule,
    NbFormFieldModule,
    NbSelectModule,
    NbTooltipModule,
  ],
  exports: [
    ConfirmationDialogComponent,
  ]
})
export class DialogsModule { }
